export const GROUPS_LIST = "GROUPS_LIST"
export const GROUPS_LIST_SUCCESS = "GROUPS_LIST_SUCCESS"
export const GROUPS_LIST_ERROR = "GROUPS_LIST_ERROR"

export const GROUPS_NEW = "GROUPS_NEW"
export const GROUPS_NEW_SUCCESS = "GROUPS_NEW_SUCCESS"
export const GROUPS_NEW_ERROR = "GROUPS_NEW_ERROR"

export const GROUPS_EDIT = "GROUPS_EDIT"

export const GROUPS_DELETE = "GROUPS_DELETE"
export const GROUPS_DELETE_SUCCESS = "GROUPS_DELETE_SUCCESS"
export const GROUPS_DELETE_ERROR = "GROUPS_DELETE_ERROR"
